import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class FolderTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (FolderTypeModel._instance == null) FolderTypeModel._instance = new FolderTypeModel(authManager);
        return FolderTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/folder-types', 'core/folder-types/codelist');

        this.entityName = 'core.FolderType';
        this.privileges = {
            create: [["#admin"]],
            read: [["#admin"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Folder Type';
        this.setLabel = 'Folder Types';

        this.browser = {
            name: 'default-core-foldertype-browser',
            moduleName: 'default-core-foldertype-browser',
            moduleTitle: 'Folder Types',
            moduleStateSlotName: 'default-core-foldertype-browser',
        };

        this.editor = {
            name: 'default-core-foldertype-editor',
            moduleName: 'default-core-foldertype-editor',
            moduleTitle: 'Folder Type',
            moduleStateSlotName: 'default-core-foldertype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
            {
                name: 'isRemovable',
                type: 'bool',
                persistent: true,
                label: 'Is Removable',
            },
            {
                name: 'icon',
                type: 'string',
                persistent: true,
                label: 'Icon',
            },
        ];

    }

}
